import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CandidateService } from 'src/app/_services/candidate.service';
import { environment } from 'src/environments/environment';

declare const clevertap;

@Component({
  selector: 'app-document-tab',
  templateUrl: './document-tab.component.html',
  styleUrls: ['./document-tab.component.scss']
})
export class DocumentTabComponent implements OnInit {
  cvDetails: any[] = [];
  previewResumeUrl: any;
  selectedCSV: any = null;
  incorrectFileFormat: boolean;
  successMessage: string = '';
  errorMessage: string = '';
  fileUploadSpinner: boolean = false;
  iscvDetailsLoader: boolean = false;

  @Input() candidateId: any;
  @Input() basicdDetails: any;
  @ViewChild('deletecv') deletecv: TemplateRef<any>;
  @Output() childEvents = new EventEmitter<{ action: string, data?: any }>();


  constructor(public modalService: NgbModal, public candidateService: CandidateService, private sanitization: DomSanitizer) { }

  ngOnInit(): void {
    this.getCandidatedocuments();
  }

  /**
   * Get candidate documents based on candidate id
   */
  getCandidatedocuments() {
    this.iscvDetailsLoader = true;
    this.candidateService.fetchcvdetails(this.candidateId).subscribe((res: any) => {
      if (res.status == 'success') {
        this.iscvDetailsLoader = false;
        this.cvDetails = res.cvdetails;
        if (this.cvDetails && this.cvDetails.length > 0) {
          const lastcv = this.cvDetails[this.cvDetails.length - 1];
          this.previewDoc(JSON.stringify(lastcv));
        }
      }
    })
  }

  previewDoc(data) {
    this.selectedCSV = JSON.parse(data);
    this.previewResumeUrl = null;
    if (this.selectedCSV) {
      this.candidateService.resumeurl(this.selectedCSV.previewurl).subscribe((res: any) => {
        var file3 = new Blob([res], { type: 'application/pdf' });
        this.previewResumeUrl = this.sanitization.bypassSecurityTrustResourceUrl(URL.createObjectURL(file3) + "#toolbar=0&navpanes=0&scrollbar=0")
      })
    }
  }

  uploadFile(e) {
    const resumeFile = e.target.files[0]
    const validFileExtensions = ['doc', 'docx', 'txt', 'pdf', 'dot', 'rtf', 'odt', 'htm', 'html'];
    const uploadedFileExtension = resumeFile.name.split('.')[1];
    this.incorrectFileFormat = !validFileExtensions.includes(uploadedFileExtension.toLowerCase()) ? true : false;
    if (!this.incorrectFileFormat) {
      this.fileUploadSpinner = true;
      this.candidateService.uploadresume(resumeFile).subscribe((res: any) => {
        if (res.status == 'success') {
          this.incorrectFileFormat = false
          if (res) {
            const data = {
              candidatenumber: this.candidateId,
              cvfilesarray: [{
                filename: res.filename,
                docurl: res.docurl,
                previewurl: res.previewurl,
                isactive: 1
              }],
              cvactivitylog: [{
                "action": "'added'",
                "type": "'CV'",
                "oldvalue": "'" + res.filename + "'",
              }]
            }
            this.candidateService.savecvfiles(data).subscribe((res: any) => {
              this.getCandidatedocuments()
              this.childEvents.emit({ action: "refresh"});
              this.showToastMessage('Document added Successfully', 'success')
              this.fileUploadSpinner = false;

              //- Clevertap Upload Document event
              let ctObj = {
                "Name": this.basicdDetails.firstname + " " + this.basicdDetails.lastname,
                "Job title": this.basicdDetails.jobtitle,
                "Company Name": this.basicdDetails.companyname,
                "Source": this.basicdDetails.source,
                "Location": this.basicdDetails.locationname,
                "Origin": "Web app"
              }
              this.cleverTapEvent("Upload Document", ctObj);
            })
          }
        }
      }, (_) => {
        this.fileUploadSpinner = false;
      })
    }
  }

  deleteCV() {
    const data = {
      candidatenumber: this.candidateId,
      cvfilesarray: [{
        filename: this.selectedCSV.filename,
        docurl: this.selectedCSV.docurl,
        previewurl: this.selectedCSV.previewurl,
        isactive: 0,
        candidatedocid: this.selectedCSV.candidatedocid
      }],
      cvactivitylog: [{
        action: "'removed'",
        type: "'CV'",
        oldvalue: "'" + this.selectedCSV.filename + "'",
        candidatedocid: "'" + this.selectedCSV.candidatedocid + "'"
      }]
    }
    this.candidateService.savecvfiles(data).subscribe((res: any) => {
      this.getCandidatedocuments();
      this.childEvents.emit({ action: "refresh"});
      this.showToastMessage('Document removed Successfully', 'success');
      this.modalService.dismissAll();
      this.selectedCSV = null;
    })
  }

  /**
   * Show toast message
   * @param message 
   * @param type 
   */
  showToastMessage(message: string, type: string) {
    const messageType = type;
    switch (messageType) {
      case 'success': this.successMessage = message;
        setTimeout(() => this.successMessage = '', 5000);
        break;
      case 'error': this.errorMessage = message;
        setTimeout(() => this.errorMessage = '', 5000);
        break;
    }
  }

  cleverTapEvent(eventName, data) {
    clevertap.event.push(eventName, data);
    console.log(eventName + " CT event");
  }

  opendeleteCVModal() {
    this.modalService.open(this.deletecv, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  previewFile(file) {
    const downloadLink = document.createElement("a");
    document.body.appendChild(downloadLink);
    downloadLink.setAttribute("href", environment.frontendurl + "/document-preview/" + this.candidateId + "/" + file.candidatedocid);
    downloadLink.setAttribute("target", "_blank");
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }


  downloadCV() {
    const downloadLink = document.createElement("a");
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.setAttribute("href", environment.backendurl + "/candidate/fetchdocument?documenturl=" + this.selectedCSV.previewurl);
    downloadLink.setAttribute("download", "fileName");
    downloadLink.setAttribute("target", "_blank");
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }
}
